import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { tap } from "rxjs";
import { CustomerContractTypeEnum, HotelDealProcessingStateEnum, SalesCommunicationActivityDirectionEnum, SalesCommunicationActivityMethodEnum, SalesCommunicationActivityTypeEnum, SalesEnumInitializationQueryResponse } from "../autogenerated/model.autogenerated";

@Injectable({
  providedIn: 'root'
})
export class EnumsService {

  private _enums: SalesEnumInitializationQueryResponse | null = null;

  public get enums() { return this._enums; }

  constructor(private readonly _api: ApiService) {

  }

  public reload(){
    this.initialize().subscribe();
  }

  public initialize() {
    return this._api.Enum_List()
      .pipe(
        tap(x => this._enums = x)
      )
  }

  public getContractStateNameById(idContractState: number) {
    return this.enums?.hotelContractStates!.find(x => x.id == idContractState)?.name!;
  }

  public getContractTypeNameById(idContractType: number) {
    return this.enums?.hotelContractTypes!.find(x => x.id == idContractType)?.name!;
  }

  public getContractAgreementNameById(idContractAgreementFormat: number) {
    return this.enums?.hotelContractAgreementFormats!.find(x => x.id == idContractAgreementFormat)?.name!;
  }

  public getRepresentativeDepartementNameById(idRepresentativeDepartement: number) {
    return this.enums?.representativeDepartements!.find(x => x.id == idRepresentativeDepartement)?.name!;
  }

  public getComunicationMethodById(idSalesCommunicationActivityMethod: SalesCommunicationActivityMethodEnum){
    return this.enums?.salesCommunicationActivityMethods!.find(x => x.id == idSalesCommunicationActivityMethod)?.name!
  }

  public getSalesActivitiesStatusById(idSalesCommunicationActivityType: SalesCommunicationActivityTypeEnum){
    return this.enums?.salesCommunicationActivityTypes!.find(x => x.id == idSalesCommunicationActivityType)?.name!
  }

  public getCommunicationDirectionById(idSalesCommunicationActivityDirection: SalesCommunicationActivityDirectionEnum){
    return this.enums?.salesCommunicationActivityDirections!.find(x => x.id == idSalesCommunicationActivityDirection)?.name!
  }

  public getHotelDealProcessingStateById(idDealProcessingState: HotelDealProcessingStateEnum) {
    return this.enums?.hotelDealProcessingStates!.find(x => x.id == idDealProcessingState)?.name!
  }

  public getCustomerContractTypeNameById(idCustomerContractType: CustomerContractTypeEnum) {
    return this.enums?.customerContractTypes!.find(x => x.id == idCustomerContractType)?.name!
  }
}
